import "../../../css/modal.css";
import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import API from "../../../utils/API";
import axios from "axios";

const Edit = ({ room, fetchrooms }) => {
  // Modal open state
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [blocks, setBlocks] = useState([]);

  const [data, setData] = useState({
    name: "",
    campus_id: "",
    block_id: "",
    dimension: "",
    seating_capacity: "",
    chair_type: "",
    multimedia_type: "",
    is_air_conditioned: 0,
    has_computer: 0,
    has_projector: 0,
    is_active: 0,
  });

  useEffect(() => {
    setData(room);
  }, []);

  useEffect(() => {
    fetchCampuses();
  }, []);

  useEffect(() => {
    fetchBlocks();
  }, []);

  const fetchCampuses = async () => {
    try {
      setLoading(true);
      const response = (await API.get("/api/campuses")).data;
      setCampuses(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchBlocks = async () => {
    try {
      setLoading(true);
      const response = (await API.get("/api/blocks")).data;
      setBlocks(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  // Toggle for Modal
  const toggle = () => setModal(!modal);

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await API.put(`api/rooms/${data.id}`, data);
      setLoading(false);
      fetchrooms();
      toggle();
      setErrors([]);
    } catch (error) {
      setErrors(
        error?.response?.data?.errors ? error.response.data.errors : []
      );
      setLoading(false);
    }
  }

  const handleChangeCheckbox = (e) => {
    if (errors.length) setErrors([]);
    setData({ ...data, [e.target.name]: e.target.checked ? 1 : 0 });
  };
  const handleChange = (e) => {
    if (errors.length) setErrors([]);
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <Button
        color="primary"
        className="btn btn-sm btn-primary d-block w-100 mb-2"
        onClick={toggle}>
        Edit
      </Button>

      <Modal
        modalClassName="custommodal"
        centered
        scrollable
        size="xl"
        toggle={toggle}
        isOpen={modal}
        fade={true}>
        <ModalHeader toggle={toggle}>Update Room</ModalHeader>
        <Form method="POST" action="#" onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="name" className="label-required">
                Name
              </Label>
              <Input
                className="rounded-2"
                id="name"
                type="text"
                name="name"
                maxLength={255}
                value={data.name}
                onChange={handleChange}
                required
                autoFocus
              />
              {errors.name && (
                <Label className="text-danger mt-2" for="name">
                  {errors.name}
                </Label>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="campus_id">Campus</Label>
              <Input
                className="rounded-2"
                id="campus_id"
                required
                type="select"
                name="campus_id"
                onChange={handleChange}
                value={data.campus_id}>
                <option value="">Select Campus</option>
                {campuses.map((campus) => (
                  <option key={campus.id} value={campus.id}>
                    {campus.name}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="block_id">Block</Label>
              <Input
                className="rounded-2"
                id="block_id"
                required
                type="select"
                name="block_id"
                value={data.block_id}
                onChange={handleChange}>
                <option value="">Select Block</option>
                {blocks.map((block) => (
                  <option key={block.id} value={block.id}>
                    {block.name}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="dimension" className="label-required">
                Dimension
              </Label>
              <Input
                className="rounded-2"
                id="dimension"
                type="text"
                name="dimension"
                maxLength={255}
                value={data.dimension}
                onChange={handleChange}
                required
                autoFocus
              />
            </FormGroup>
            <FormGroup>
              <Label for="seating_capacity" className="label-required">
                Seating Capacity
              </Label>
              <Input
                className="rounded-2"
                id="seating_capacity"
                type="text"
                name="seating_capacity"
                maxLength={255}
                value={data.seating_capacity}
                onChange={handleChange}
                required
                autoFocus
              />
            </FormGroup>

            <FormGroup>
              <Label for="chair_type" className="label-required">
                Chair Type
              </Label>
              <Input
                className="rounded-2"
                id="chair_type"
                type="text"
                name="chair_type"
                maxLength={255}
                value={data.chair_type}
                onChange={handleChange}
                required
                autoFocus
              />
            </FormGroup>
            <FormGroup>
              <Label for="multimedia_type" className="label-required">
                Multimedia Type
              </Label>
              <Input
                className="rounded-2"
                id="multimedia_type"
                type="text"
                name="multimedia_type"
                maxLength={255}
                value={data.multimedia_type}
                onChange={handleChange}
                required
                autoFocus
              />
            </FormGroup>
            <div className="row mt-4">
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_air_conditioned" className="label-required">
                    Air Conditioned
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_air_conditioned"
                    type="checkbox"
                    name="is_air_conditioned"
                    maxLength={255}
                    value={data.is_air_conditioned}
                    checked={data.is_air_conditioned}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
              <div className="col-md-4">
                <FormGroup>
                  <Label for="has_computer" className="label-required">
                    Computer
                  </Label>
                  <Input
                    className="rounded-2"
                    id="has_computer"
                    type="checkbox"
                    name="has_computer"
                    maxLength={255}
                    value={data.has_computer}
                    checked={data.has_computer}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <FormGroup>
                  <Label for="has_projector" className="label-required">
                    Projector
                  </Label>
                  <Input
                    className="rounded-2"
                    id="has_projector"
                    type="checkbox"
                    name="has_projector"
                    maxLength={255}
                    value={data.has_projector}
                    checked={data.has_projector}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
              <div className="col-md-4">
                <FormGroup>
                  <Label for="is_active" className="label-required">
                    Active
                  </Label>
                  <Input
                    className="rounded-2"
                    id="is_active"
                    type="checkbox"
                    name="is_active"
                    maxLength={255}
                    value={data.is_active}
                    checked={data.is_active}
                    onChange={handleChangeCheckbox}
                  />
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={toggle}
              color="light"
              className="rounded-2">
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              className="rounded-2"
              disabled={loading}>
              {loading && (
                <Spinner className="me-2" size="sm">
                  Loading...
                </Spinner>
              )}
              Update
            </Button>{" "}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default Edit;
